import React from 'react';
import { X, BarChart3 } from 'lucide-react';
import EmailReportSection from './EmailReportSection';
import MetricsChartsContainer from './MetricsChartsContainer';

interface UsageMetricsProps {
  isUsageMetrcisModalOpen: boolean;
  setIsUsageMetricsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  assistant: any;
  triggerAutoSave: () => void; 
  isMetricsEmail: boolean
  setMetricsEmail: React.Dispatch<React.SetStateAction<boolean>>;
  metricsEmailAddress: string
  setMetricsEmailAddress: (val: string) => void;
}

const UsageMetrics: React.FC<UsageMetricsProps> = ({
  isUsageMetrcisModalOpen,
  setIsUsageMetricsModalOpen,
  assistant,
  triggerAutoSave, 
  isMetricsEmail,
  setMetricsEmail,
  metricsEmailAddress,
  setMetricsEmailAddress
}) => {
  return (
    <div
      className={`fixed inset-0 bg-gray-900 bg-opacity-70 flex justify-center items-center z-60 overflow-auto ${
        isUsageMetrcisModalOpen ? 'block' : 'hidden'
      }`}
      onClick={() => setIsUsageMetricsModalOpen(false)}
    >
      <div
        className="bg-white w-[90%] h-[80%] shadow-lg rounded-lg flex flex-col overflow-auto"  
        onClick={(e) => e.stopPropagation()}
      >
        {/* Enhanced Header */}
        <div className="p-4 text-black">
          <div className="flex justify-between items-center">
            {/* Left Section: Title */}
            <div className="flex items-center space-x-4">
              <BarChart3 className="h-8 w-8" />
              <h2 className="text-xl font-semibold text-gray-800">Usage Metrics</h2>
            </div>

            {/* Right Section: Close Button */}
            <div className="flex items-center space-x-3">
              <button
                onClick={() => setIsUsageMetricsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Dashboard Content */}
        <hr className="mt-4" />
       
        <div className="p-4 grid grid-cols-1 lg:grid-cols-2 gap-6 overflow-y-auto bg-gray-50 mb-5">
          {/* Email Report Section */}
          <EmailReportSection
            isMetricsEmail={isMetricsEmail}
            setMetricsEmail={setMetricsEmail}
            metricsEmailAddress={metricsEmailAddress}
            setMetricsEmailAddress={setMetricsEmailAddress}
            triggerAutoSave={triggerAutoSave}
          />

          {/* Charts Container */}
          <MetricsChartsContainer
            assistant={assistant}
            isUsageMetricsModalOpen={isUsageMetrcisModalOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default UsageMetrics;